// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import axios from 'axios'
import 'babel-polyfill'
import Toasted from 'vue-toasted';
Vue.use(Toasted)
Vue.use(Vuetify)

Vue.config.productionTip = false
axios.defaults.baseURL = 'http://zlecenia.luxwent.pl';
// axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

// router.beforeEach((to, from, next) => {
//   if(!localStorage.getItem('token')){
   
//     next( this.$router.push('/'));
//   }
//   next();
  
// })
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js